import BaseComponent from "@js/components/base_component.jsx";

import MuiUserRolesTable from "@js/components/mui/user_roles/table.jsx";

class MuiUserRolesIndex extends BaseComponent {

  render() {
    return (
      <Panel heading="users">
        <MuiUserRolesTable
          users={ this.props.user_roles }
          is_index={ true }
          is_master_account={ this.props.is_master_account }
        />
      </Panel>
    );
  }

}

export default MuiUserRolesIndex;
